import dayjs from 'dayjs';

export function getFullDate(value?: string) {
  if (!value) {
    return "";
  }

  return dayjs(value).format("YYYY-MM-DD hh:mm A");
}
